var map = {
	"./afterburn.svg": "1ba0",
	"./airtight-hatch.svg": "1799",
	"./alien-bug.svg": "d42e",
	"./alien-egg.svg": "5f96",
	"./alien-stare.svg": "327c",
	"./android-mask.svg": "dd34",
	"./astronaut-helmet.svg": "11a5",
	"./autogun.svg": "aeeb",
	"./bolter-gun.svg": "d912",
	"./bubble-field.svg": "62f4",
	"./cannister.svg": "fe92",
	"./cryo-chamber.svg": "869b",
	"./cyborg-face.svg": "0f8e",
	"./defense-satellite.svg": "5605",
	"./double-ringed-orb.svg": "ea96",
	"./eclipse.svg": "e058",
	"./energise.svg": "c715",
	"./energy-tank.svg": "d1f5",
	"./forward-field.svg": "b102",
	"./habitat-dome.svg": "3bb4",
	"./hazmat-suit.svg": "7124",
	"./jet-fighter.svg": "6d2f",
	"./jetpack.svg": "16c3",
	"./klingon.svg": "98f3",
	"./laser-blast.svg": "a6c7",
	"./laser-turret.svg": "eeea",
	"./light-sabers.svg": "620c",
	"./lunar-module.svg": "53d9",
	"./mecha-head.svg": "777b",
	"./mecha-mask.svg": "a208",
	"./mechanical-arm.svg": "fe7c",
	"./megabot.svg": "a697",
	"./metal-scales.svg": "d86f",
	"./metroid.svg": "c607",
	"./missile-mech.svg": "163a",
	"./missile-pod.svg": "c836",
	"./missile-swarm.svg": "80b2",
	"./mono-wheel-robot.svg": "5225",
	"./observatory.svg": "b3c1",
	"./pirate.svg": "5cf8",
	"./power-generator.svg": "5eb0",
	"./radar-dish.svg": "00d6",
	"./ray-gun.svg": "61cd",
	"./ringed-planet.svg": "64a5",
	"./robot-golem.svg": "dfe6",
	"./robot-leg.svg": "1457",
	"./rocket-flight.svg": "7222",
	"./rocket-thruster.svg": "e3b6",
	"./rocket.svg": "d9f0",
	"./round-silo.svg": "4746",
	"./sattelite.svg": "65bd",
	"./sentry-gun.svg": "e908",
	"./sinusoidal-beam.svg": "27e5",
	"./solar-system.svg": "4677",
	"./space-suit.svg": "e017",
	"./spaceship.svg": "1958",
	"./spoutnik.svg": "6b38",
	"./star-gate.svg": "f957",
	"./starfighter.svg": "8ce3",
	"./strafe.svg": "b56b",
	"./targeting.svg": "d318",
	"./techno-heart.svg": "a56e",
	"./tesla-turret.svg": "1230",
	"./ufo.svg": "4312",
	"./vintage-robot.svg": "757d",
	"./walking-scout.svg": "177b",
	"./zat-gun.svg": "7ee7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21a5";